import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)

const state = {
  doctorIndexInfo:null,  //医生首页信息
  doctorCenterInfo:null,  //医生个人中心信息
  navIndex:null,
  selectPatient:null,  //选择视频会诊的患者
  seeType:null,   //进入聊天页面的途径（图文 / 视频）
  inquiryDetail:null,   //问诊单详情,
  selectMedical : null,
  doctorToken: null,  //专家登录Token
  reservePatientList: null, // 视频患者数据
  loginPhone: '',  // 登录使用的手机号码
  isHasCamera: true, // 是否有摄像头
};
export default {
  state,
  mutations,
  getters,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/common/index.js